var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found"},[_c('img',{attrs:{"src":require("../../assets/waiting-man.svg")}}),_c('h1',{staticClass:"heading-2"},[_vm._v(_vm._s(_vm.title))]),(_vm.btnText)?_c('v-btn',{attrs:{"color":"primary","outlined":""},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(_vm._s(_vm.btnText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }